// Service
import { PdfService } from './service/pdf.service';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { DragDropModule } from 'primeng/dragdrop';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { FieldsetModule } from 'primeng/fieldset';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { TableGenericComponent } from '../../general/table-generic/table-generic.component';
import { TableService } from './service/table.service';
import { IModificarPdf } from './interface/modificar.interface';
import { BotoneraService } from '../botonera.service';
import { UserInteractiveService } from '@/Services/user-interactive.service';
import { ModalDescriptionPublishComponent } from './components/modal-description-publish/modal-description-publish.component';
import { lastValueFrom } from 'rxjs';
import { ModalUploadFileComponent } from './components/modal-upload-file/modal-upload-file.component';

@Component({
  selector: 'app-modal-modificar-pdf',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    CheckboxModule,
    TooltipModule,
    DragDropModule,
    FieldsetModule,
    ButtonGroupModule,
    TableGenericComponent,
  ],
  templateUrl: './modal-modificar-pdf.component.html',
  styleUrl: './modal-modificar-pdf.component.scss',
  providers: [DialogService],
})
export class ModalModificarPdfComponent implements OnInit {
  @Input() titulo = 'Dividir archivo por páginas';

  searchText = '';
  selectedFiles: IModificarPdf[] = [];
  idfdArchivo = signal<number>(0);

  // services
  pdfService = inject(PdfService);
  tableService = inject(TableService);
  botoneraService = inject(BotoneraService);
  userInteractive = inject(UserInteractiveService);
  refDialogService = inject(DynamicDialogRef);
  configDialogService = inject(DynamicDialogConfig);

  constructor(){
    this.tableService.reset();
  }

  async ngOnInit() {
    this.idfdArchivo.set(this.configDialogService.data);
    const data = await this.pdfService.getListPages(this.configDialogService.data);
    await this.initData(data);
  }

  async initData(data: IModificarPdf[]) {    
    this.tableService.data.set(data);
    this.tableService.dataSelected.set(data.filter((item) => item.Estado2));
  }

  async viewOriginal() {
    await this.pdfService.getBackup(this.idfdArchivo());
  }

  async preview() {
    await this.pdfService.getPreview(this.idfdArchivo());
  }

  async publish() {
    const config: DynamicDialogConfig = { header: 'Publicar documento', data: this.idfdArchivo(), height: '200px', width: '50%', templates: {} };
    const publish = this.userInteractive.openDialog(ModalDescriptionPublishComponent, config);
    const isClose = await lastValueFrom(publish.onClose);

    if (isClose) {
      this.refDialogService.close(true);
    }
  }

  async addFile() {
    const config: DynamicDialogConfig = { header: 'Subir archivo', data: this.idfdArchivo(), width: '50%', templates: {} };
    const upload = this.userInteractive.openDialog(ModalUploadFileComponent, config);
    const data = await lastValueFrom(upload.onClose);

    if (data) {
      await this.initData(data);
    }
  }    
}
